import { useRef, useState } from "react";
import { Button, Grid, FormHelperText } from "@mui/material";
import { FileUploadOutlined } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../../../../../helpers/api/Api";
import ApiUrls from "../../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../../helpers/api/errors/ShowStatus";
import { appendFormData } from "../../../../../../helpers/functions/form-append";

function SelfManaged({ domain, handleClose }) {
  const [formData, setFormData] = useState({
    uid: domain.id,
    cert: "", // HTTPS Certificate (File) (Mandatory if certmanaged=0)
    privkey: "", // HTTPS Private Key (File) (Mandatory if certmanaged=0)
  });
  const {
    cert,
    privkey,
  } = formData;
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const certInput = useRef(null);
  const privkeyInput = useRef(null);

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const handleUpload = (name, event) => {
    const fileUploaded = event.target.files[0];
    handleChange(name, fileUploaded);
  };

  const checkInputs = () => {
    let temp_errors = {};

    if (cert === "") {
      temp_errors.cert = t("message.required_upload", { item: t("domain.certificate") });
    }
    if (privkey === "") {
      temp_errors.privkey = t("message.required_upload", { item: t("domain.private_key") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      uploadKeys();
    }
  }

  const uploadKeys = () => {
    setLoading(true);
    const snackArgs = {
      item: t("button.file"),
      op: t("global.done")
    };

    const postFormData = appendFormData(formData);

    api.post(ApiUrls.domain.uploadKeys, postFormData)
      .then((response) => {
        setLoading(false);
        showStatus(response.data.status, snackArgs);
        if (response.data.status === "success") {
          handleClose();
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  return (
    <>
      <Grid container spacing={2} justifyContent="center">
        <Grid md={4} mt={3} className="d-flex flex-column align-items-center">
          <div className="d-flex align-items-center">
            <span className="custom-label ms-2">{t("domain.certificate")}:</span>
            <Button
              variant="outlined" startIcon={<FileUploadOutlined />} size="small" className="button-fw-normal"
              onClick={() => certInput.current.click()}
            >
              {t("button.file")}
              <input
                ref={certInput}
                style={{ display: "none" }}
                type="file"
                onChange={(e) => handleUpload("cert", e)}
              />
            </Button>
          </div>
          <FormHelperText error={errors?.cert} className="mt-2">
            {cert
              ? cert.name
              : errors.cert
            }
          </FormHelperText>
        </Grid>

        <Grid md={4} mt={3} className="d-flex flex-column align-items-center">
          <div className="d-flex align-items-center">
            <span className="custom-label ms-2">{t("domain.private_key")}:</span>
            <Button
              variant="outlined" startIcon={<FileUploadOutlined />} size="small" className="button-fw-normal"
              onClick={() => privkeyInput.current.click()}
            >
              {t("button.file")}
              <input
                ref={privkeyInput}
                style={{ display: "none" }}
                type="file"
                onChange={(e) => handleUpload("privkey", e)}
              />
            </Button>
          </div>
          <FormHelperText error={errors?.privkey} className="mt-2">
            {privkey
              ? privkey.name
              : errors.privkey
            }
          </FormHelperText>
        </Grid>
      </Grid>

      <Grid container mt={3} justifyContent="center">
        <Grid item md={3} mt={5}>
          <LoadingButton
            color="info"
            loading={loading}
            variant="outlined"
            fullWidth
            onClick={checkInputs}
          >
            {t("button.file")}
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
}

export default SelfManaged;
